import {
  IonButton,
  IonButtons,
  IonHeader,
  IonIcon,
  IonTitle,
  IonToolbar,
} from '@ionic/react';
import { close } from 'ionicons/icons';
import { isNil } from 'lodash';
import { ReactElement, useMemo } from 'react';
import { FullScreenIonModal } from '../../../../../components/modal/full-screen-ion-modal';
import { getLocalizedText } from '../../../../../i18n/i18n.utils';
import {
  ApplicationSettingsBucketEdit,
  ApplicationSettingsBucketEditProps,
} from './application-settings-bucket-edit';

export interface ApplicationSettingsBucketEditModalProps
  extends ApplicationSettingsBucketEditProps {
  isOpen: boolean;
  isFullScreen?: boolean;
  presentingElement?: HTMLElement;
  onClose: () => void;
  useDefaultParams?: boolean;
}

const ApplicationSettingsBucketEditModal = (
  props: ApplicationSettingsBucketEditModalProps
): ReactElement => {
  const {
    isOpen,
    isFullScreen,
    bucketId,
    onSave,
    onClose,
    bucketData,
    presentingElement,
    tagsReadOnly,
    applicationParametersReadOnly,
    system,
    sourceBucketId,
    tags,
    useDefaultParams,
    type,
  } = props;

  const isNew = useMemo(() => {
    return isNil(bucketId);
  }, [bucketId]);

  const modalHeader = useMemo(() => {
    return isNew
      ? getLocalizedText('common:application_settings_writer_create_header')
      : getLocalizedText('common:application_settings_writer_update_header');
  }, [isNew]);

  return (
    <FullScreenIonModal
      isOpen={isOpen}
      isFullScreen={isFullScreen}
      canDismiss={true}
      presentingElement={presentingElement}
      onDidDismiss={() => onClose()}
    >
      <IonHeader>
        <IonToolbar>
          <IonButtons slot={'start'}>
            <IonButton onClick={() => onClose()}>
              <IonIcon icon={close} size="large" />
            </IonButton>
          </IonButtons>
          <IonTitle>{modalHeader}</IonTitle>
        </IonToolbar>
      </IonHeader>
      {isOpen && (
        <ApplicationSettingsBucketEdit
          onSave={onSave}
          bucketId={bucketId}
          bucketData={bucketData}
          tagsReadOnly={tagsReadOnly}
          applicationParametersReadOnly={applicationParametersReadOnly}
          system={system}
          sourceBucketId={sourceBucketId}
          tags={tags}
          useDefaultParams={useDefaultParams}
          type={type}
        />
      )}
    </FullScreenIonModal>
  );
};

export { ApplicationSettingsBucketEditModal };
